interface WarningCircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WarningCircleSVG = ({ color, style }: WarningCircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.4165 17.0003C1.4165 25.6068 8.3934 32.5837 16.9998 32.5837C25.6063 32.5837 32.5832 25.6068 32.5832 17.0003C32.5832 8.39389 25.6063 1.41699 16.9998 1.41699C8.3934 1.41699 1.4165 8.39389 1.4165 17.0003ZM29.7498 17.0003C29.7498 24.042 24.0415 29.7503 16.9998 29.7503C9.95821 29.7503 4.24984 24.042 4.24984 17.0003C4.24984 9.95869 9.95821 4.25033 16.9998 4.25033C24.0415 4.25033 29.7498 9.95869 29.7498 17.0003ZM17.0003 25.498C17.783 25.498 18.4174 24.8637 18.4174 24.0813C18.4174 23.2989 17.783 22.6646 17.0003 22.6646C16.2176 22.6646 15.5832 23.2989 15.5832 24.0813C15.5832 24.8637 16.2176 25.498 17.0003 25.498ZM18.4216 8.49798H15.5874V19.8313H18.4216V8.49798Z"
      fill={color}
    />
  </svg>
);

export default WarningCircleSVG;
